import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { UserManagement } from '../components/Admin/UserManagement';

export const AdminUsersPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <UserManagement />
      </div>
    </Layout>
  );
};
